export const STATUTS_RECLAMATION = {
  nouvelle: { label: 'Nouvelle', badge: 'bg-red-100 text-red-800 border-red-200' },
  en_cours: { label: 'En cours de traitement', badge: 'bg-amber-100 text-amber-800 border-amber-200' },
  traitee: { label: 'Traitée', badge: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  cloturee: { label: 'Clôturée', badge: 'bg-slate-100 text-slate-600 border-slate-200' },
};

export const ORIGINES_RECLAMATION = {
  stagiaire: 'Stagiaire', tuteur: 'Tuteur', entreprise: 'Entreprise', candidat: 'Candidat', formateur: 'Formateur', financeur: 'Financeur', autre: 'Autre',
};

export const CANAUX = {
  application: 'Application FISL', email: 'E-mail', telephone: 'Téléphone', courrier: 'Courrier', oral: 'Oral / sur place',
};

export const STATUTS_ACTION = {
  a_faire: { label: 'À faire', badge: 'bg-slate-100 text-slate-700 border-slate-200' },
  en_cours: { label: 'En cours', badge: 'bg-amber-100 text-amber-800 border-amber-200' },
  realisee: { label: 'Réalisée', badge: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  abandonnee: { label: 'Abandonnée', badge: 'bg-slate-100 text-slate-400 border-slate-200 line-through' },
};

export const ORIGINES_ACTION = {
  reclamation: 'Réclamation', questionnaire: 'Questionnaire de satisfaction', audit: 'Audit', equipe: "Réunion d'équipe", conseil: 'Conseil de perfectionnement', risque: 'Analyse des risques', autre: 'Autre',
};

export const Badge = ({ meta, testId }) => (
  <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${meta.badge}`} data-testid={testId}>{meta.label}</span>
);

export const Filtres = ({ options, valeur, onChange, compteurs, prefixe }) => (
  <div className="flex flex-wrap gap-2">
    {[['', 'Toutes'], ...Object.entries(options).map(([k, v]) => [k, v.label])].map(([k, l]) => (
      <button key={k || 'tout'} type="button" onClick={() => onChange(k)}
        className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${valeur === k ? 'border-[#0F172A] bg-[#0F172A] text-white' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-400'}`}
        data-testid={`${prefixe}-filtre-${k || 'tout'}`}>
        {l}{compteurs?.[k || 'tout'] !== undefined ? ` (${compteurs[k || 'tout']})` : ''}
      </button>
    ))}
  </div>
);

export const compterPar = (items, champ) => items.reduce((acc, i) => ({ ...acc, [i[champ]]: (acc[i[champ]] || 0) + 1 }), { tout: items.length });

export const aujourdhui = () => new Date().toISOString().slice(0, 10);
